// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gloria+Hallelujah&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instructionalOverlay-background {
    background-color: rgba(0, 0, 0, 0.5);
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    cursor: pointer;
    z-index: 9;
  }

  .instructionalOverlay-focus {
    display: block;
  }
  
  .instructionalOverlay-container {
    background-color: transparent;
    color: white;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    z-index: 10;
    padding: 30px;
    /* width: fit-content;
    height: fit-content; */
  }
  
  .instructionalOverlay-controls {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  
  .instructionalOverlay-close:after {
    display: inline-block;
    content: "\\00d7";
  }
  
  .instructionalOverlay-close {
    border: none;
    background-color: transparent;
    font-size: 36px;
    cursor: pointer;
    color: #eb590a;
  }

  .swipe-text {
    font-family: 'Gloria Hallelujah', cursive !important;
    font-size: 24px;
    color: white;
    z-index: 11;
  }
  .swipe-text.right {
    position: relative;
    margin-top: 75px;
    margin-right: 124px;
    float: right;
  }
  .swipe-text.right i {
    margin-left: 10px;
  }

  .swipe-text.left {
    position: relative;
    margin-top: 183px;
    float: left;
    margin-left: 160px;
  }
  .swipe-text.left i {
    margin-right: 10px;
  }

  .swipe-text.comment {
    position: absolute;
    text-align: center;
    margin: 0 auto;
    width: 100%;
    z-index: 10;
  }
  .swipe-text.comment i {
    display: block;
  }
  .swipe-text.question i {
    display: block;
  }
  .got-btn {
    position: fixed;
    bottom: 20px;
    z-index: 11;
  }

  .swipe-text.question {
    position: absolute;
    top: -50px;
    z-index: 10;
  }

  #instruction-overlay-div {
    box-shadow: unset;
    /* transform: unset;
    top: 36%; */
    background: unset;
    border: unset;
    
}

.inst-over-trans {
  z-index: 99;
}
#instruction-overlay-auth-div {
    box-shadow: unset;
    /* transform: unset;
    top: 22%; */
    background: unset;
    border: unset;
}
.swipe-text.swipe-un-auth-text.right {
  margin: 0 !important;
  right: -20px;
  position: absolute;
  top: 0;
}
.swipe-text.swipe-un-auth-text.left {
  margin: 0 !important;
  left: 0;
  position: absolute;
  bottom: 0;
}

  /* @media (min-width: 1025px) and (max-width: 1199.98px) {
    .swipe-text.right {
      margin-right: 30px;
    }
    .swipe-text.left {
      margin-left: 65px;
    }
  }

  @media (min-width: 992px) and (max-width: 1024.98px) {
    .swipe-text.right {
      margin-right: 130px;
    }
    .swipe-text.left {
      margin-top: 75px;
      margin-left: 165px;
    }
  }

  @media (min-width: 768px) and (max-width: 991.98px) {
    .swipe-text.right {
      margin-top: 142px;
      margin-right: 31px;
    }
    .swipe-text.left {
      margin-top: 253px;
      margin-left: 49px;
    }
    .swipe-text {
      font-size: 20px;
    }
    .swipe-text.right i {
      font-size: 20px;
      margin: auto;
    }
    .swipe-text.left i {
      font-size: 20px;
      margin: auto;
    }
    .swipe-text.comment i {
      font-size: 20px;
      margin: auto;
    }
    .swipe-text.question i {
      font-size: 20px;
      margin: auto;
    }
  }

  @media (min-width: 541px) and (max-width: 767.98px) {
    .swipe-text.right {
      margin-top: 75px;
      margin-right: 30px;
    }
    .swipe-text.left {
      margin-top: 195px;
      margin-left: -40px;
    }
    .swipe-text {
      font-size: 15px;
    }
    .swipe-text.right i {
      font-size: 15px;
    }
    .swipe-text.left i {
      font-size: 15px;
    }
    .swipe-text.comment i {
      font-size: 15px;
    }
    .swipe-text.question i {
      font-size: 15px;
    }
  }

  @media (min-width: 400px) and (max-width: 540.98px) {
    .swipe-text.right {
      margin-top: 43px;
      margin-right: 5px;
    }
    .swipe-text.left {
      margin-top: 121px;
      margin-left: -10px;
    }
    .swipe-text {
      font-size: 15px;
    }
    .swipe-text.right i {
      font-size: 15px;
    }
    .swipe-text.left i {
      font-size: 15px;
    }
    .swipe-text.comment i {
      font-size: 15px;
    }
    .swipe-text.question i {
      font-size: 15px;
    }
  }

  @media (min-width: 300px) and (max-width: 399.98px) {
    .swipe-text.right {
      margin-top: 37px;
      margin-right: -15px;
    }
    .swipe-text.left {
      margin-top: 121px;
      margin-left: 0px;
    }
    .swipe-text {
      font-size: 15px;
    }
    .swipe-text.right i {
      font-size: 15px;
    }
    .swipe-text.left i {
      font-size: 15px;
    }
    .swipe-text.comment i {
      font-size: 15px;
    }
    .swipe-text.question i {
      font-size: 15px;
    }
  } */

  /* -----------new responsive---------- */
  /* @media (max-width: 1920px) { 
    .swipe-text.right {
      margin-top: 145px;
      margin-right: 144px;
    }
    .swipe-text.left {
      margin-top: 250px;
      margin-left: 170px;
    }
  }
  @media (max-width: 1600px) { 
    .swipe-text.right {
      margin-top: 105px;
    }
    .swipe-text.left {
      margin-top: 220px;
    }
  } 
  @media (max-width: 1536px) { 
    .swipe-text.right {
      margin-top: 95px;
    }
    .swipe-text.left {
      margin-top: 210px;
    }
  } 
  @media (max-width: 1440px) { 
    .swipe-text.right {
      margin-top: 85px;
    }
    .swipe-text.left {
      margin-top: 200px;
    }
  } 
  @media (max-width: 1336px) { 
    .swipe-text.right {
      margin-top: 75px;
    }
    .swipe-text.left {
      margin-top: 190px;
    }
  } 
  @media (max-width: 1280px) { 
    .swipe-text{
      font-size: 20px;
    }
    .swipe-text i {
      font-size: 26px !important;
    }
  } 
  @media (max-width: 912px) { 
    .swipe-text.right {
      margin-right: 34px;
      margin-top: 195px;
    }
    .swipe-text.left {
      margin-left: 60px;
      margin-top: 310px;
    }    
  }
  @media (max-width: 884.98px) { 
    .swipe-text.right {
      margin-top: 135px;
    }
    .swipe-text.left {
      margin-top: 250px;
    }    
  }
  @media (max-width: 834.98px) { 
    .swipe-text{
      font-size: 18px;
    }
    .swipe-text.right {
      margin-top: 155px;
      margin-right: 34px;
    }
    .swipe-text.left {
      margin-top: 260px;
      margin-left: 60px;
    }  
    #instruction-overlay-div {
      top: 32%;
  }    
  #instruction-overlay-auth-div {
    top: 32%;
}    
  }
  @media (max-width: 820.98px) { 
    .swipe-text.right {
      margin-top: 145px;
    }
    .swipe-text.left {
      margin-top: 260px;
    }    
  }
  @media (max-width: 800.98px) { 
    .swipe-text.right {
      margin-top: 165px;
    }
    .swipe-text.left {
      margin-top: 280px;
    }    
  }
  @media (max-width: 768.98px) { 
    .swipe-text{
      font-size: 18px;
    }
    .swipe-text.right {
      margin-right: 34px;
      margin-top: 115px;
    }
    .swipe-text.left {
      margin-left: 60px;
      margin-top: 230px;
    }  
    #instruction-overlay-div {
      top: 28%;
  }      
  #instruction-overlay-auth-div {
    top: 22%;
} 
  }

  @media (max-width: 540.98px) { 
    .swipe-text.right {
      margin-right: 4px;
      margin-top: 45px;
    }
    .swipe-text.left {
      margin-top: 100px;
      margin-left: -10px;
    }    
  }

  @media (max-width: 425.98px) { 
    .swipe-text{
      font-size: 14px;
    }
    .swipe-text.right {
      margin-right: 4px;
      margin-top: 25px;
    }
    .swipe-text.left {
      margin-top: 115px;
      margin-left: -10px;
    } 
    #instruction-overlay-div {
      top: 16%;
  }   
  #instruction-overlay-auth-div {
    top: 16%;
}   
  }
  @media (max-width: 414.98px) { 
    .swipe-text.right {
      margin-right: 4px;
      margin-top: 60px;
    }
    .swipe-text.left {
      margin-left: 0px;
    } 
  }
  @media only screen and (max-width: 600px) and (min-width: 400px)  {
    #instruction-overlay-auth-div {
      top: 22%;
  }   
  }
  @media (max-width: 393.98px) { 
    .swipe-text{
      font-size: 14px;
    }
    .swipe-text.right {
      margin-right: -6px;
      margin-top: 50px;
    }
    .swipe-text.left {
      margin-left: 10px;
    }    
  }
  @media (max-width: 390.98px) { 
    .swipe-text.right {
      margin-top: 35px;
    }
    .swipe-text.left {
      margin-left: 10px;
    }    
  }
  @media (max-width: 375.98px) { 
    .swipe-text.right {
      margin-right: -16px;
      margin-top: 25px;
    }
    .swipe-text.left {
      margin-top: 115px;
      margin-left: 10px;
    }    
  }
  @media (max-width: 360.98px) { 
    .swipe-text.right {
      margin-top: 45px;
  }
  }
  @media (max-width: 320.98px) { 
    .swipe-text{
      font-size: 12px;
    }
    .swipe-text i {
      font-size: 20px !important;
    }
    .swipe-text.right {
      margin-top: 35px;
  }
  }
  @media (max-width: 280.98px) { 
    .swipe-text.left {
      margin-left: 2px;
  }
  .swipe-text.right {
    margin-top: 35px;
}
  } */

  @media (max-width: 1280px) { 
    .swipe-text{
      font-size: 20px;
    }
    .swipe-text i {
      font-size: 26px !important;
    }
  } 
  @media (max-width: 834.98px) { 
    .swipe-text{
      font-size: 18px;
    }
    
}    
  @media (max-width: 540.98px) { 
    .swipe-text{
      font-size: 14px;
    }
  }
  @media (max-width: 320.98px) { 
    .swipe-text{
      font-size: 12px;
    }
    .swipe-text i {
      font-size: 20px !important;
    }
  }
  @media only screen and (max-width: 414px) and (min-width: 320px)  {
    .progress-bar-container {
      margin-bottom: 140px;
    }
  }  `, "",{"version":3,"sources":["webpack://./src/app/modules/questionaire/containers/InstructionalOverlay.css"],"names":[],"mappings":"AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,YAAY;IACZ,WAAW;IACX,aAAa;IACb;0BACsB;EACxB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,oDAAoD;IACpD,eAAe;IACf,YAAY;IACZ,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB;eACW;IACX,iBAAiB;IACjB,aAAa;;AAEjB;;AAEA;EACE,WAAW;AACb;AACA;IACI,iBAAiB;IACjB;eACW;IACX,iBAAiB;IACjB,aAAa;AACjB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,oBAAoB;EACpB,OAAO;EACP,kBAAkB;EAClB,SAAS;AACX;;EAEE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA6HG;;EAEH,wCAAwC;EACxC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA4NG;;EAEH;IACE;MACE,eAAe;IACjB;IACA;MACE,0BAA0B;IAC5B;EACF;EACA;IACE;MACE,eAAe;IACjB;;AAEJ;EACE;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,eAAe;IACjB;IACA;MACE,0BAA0B;IAC5B;EACF;EACA;IACE;MACE,oBAAoB;IACtB;EACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Gloria+Hallelujah&display=swap');\n\n.instructionalOverlay-background {\n    background-color: rgba(0, 0, 0, 0.5);\n    width: 100vw;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    left: 0;\n    cursor: pointer;\n    z-index: 9;\n  }\n\n  .instructionalOverlay-focus {\n    display: block;\n  }\n  \n  .instructionalOverlay-container {\n    background-color: transparent;\n    color: white;\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: auto;\n    z-index: 10;\n    padding: 30px;\n    /* width: fit-content;\n    height: fit-content; */\n  }\n  \n  .instructionalOverlay-controls {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n  }\n  \n  .instructionalOverlay-close:after {\n    display: inline-block;\n    content: \"\\00d7\";\n  }\n  \n  .instructionalOverlay-close {\n    border: none;\n    background-color: transparent;\n    font-size: 36px;\n    cursor: pointer;\n    color: #eb590a;\n  }\n\n  .swipe-text {\n    font-family: 'Gloria Hallelujah', cursive !important;\n    font-size: 24px;\n    color: white;\n    z-index: 11;\n  }\n  .swipe-text.right {\n    position: relative;\n    margin-top: 75px;\n    margin-right: 124px;\n    float: right;\n  }\n  .swipe-text.right i {\n    margin-left: 10px;\n  }\n\n  .swipe-text.left {\n    position: relative;\n    margin-top: 183px;\n    float: left;\n    margin-left: 160px;\n  }\n  .swipe-text.left i {\n    margin-right: 10px;\n  }\n\n  .swipe-text.comment {\n    position: absolute;\n    text-align: center;\n    margin: 0 auto;\n    width: 100%;\n    z-index: 10;\n  }\n  .swipe-text.comment i {\n    display: block;\n  }\n  .swipe-text.question i {\n    display: block;\n  }\n  .got-btn {\n    position: fixed;\n    bottom: 20px;\n    z-index: 11;\n  }\n\n  .swipe-text.question {\n    position: absolute;\n    top: -50px;\n    z-index: 10;\n  }\n\n  #instruction-overlay-div {\n    box-shadow: unset;\n    /* transform: unset;\n    top: 36%; */\n    background: unset;\n    border: unset;\n    \n}\n\n.inst-over-trans {\n  z-index: 99;\n}\n#instruction-overlay-auth-div {\n    box-shadow: unset;\n    /* transform: unset;\n    top: 22%; */\n    background: unset;\n    border: unset;\n}\n.swipe-text.swipe-un-auth-text.right {\n  margin: 0 !important;\n  right: -20px;\n  position: absolute;\n  top: 0;\n}\n.swipe-text.swipe-un-auth-text.left {\n  margin: 0 !important;\n  left: 0;\n  position: absolute;\n  bottom: 0;\n}\n\n  /* @media (min-width: 1025px) and (max-width: 1199.98px) {\n    .swipe-text.right {\n      margin-right: 30px;\n    }\n    .swipe-text.left {\n      margin-left: 65px;\n    }\n  }\n\n  @media (min-width: 992px) and (max-width: 1024.98px) {\n    .swipe-text.right {\n      margin-right: 130px;\n    }\n    .swipe-text.left {\n      margin-top: 75px;\n      margin-left: 165px;\n    }\n  }\n\n  @media (min-width: 768px) and (max-width: 991.98px) {\n    .swipe-text.right {\n      margin-top: 142px;\n      margin-right: 31px;\n    }\n    .swipe-text.left {\n      margin-top: 253px;\n      margin-left: 49px;\n    }\n    .swipe-text {\n      font-size: 20px;\n    }\n    .swipe-text.right i {\n      font-size: 20px;\n      margin: auto;\n    }\n    .swipe-text.left i {\n      font-size: 20px;\n      margin: auto;\n    }\n    .swipe-text.comment i {\n      font-size: 20px;\n      margin: auto;\n    }\n    .swipe-text.question i {\n      font-size: 20px;\n      margin: auto;\n    }\n  }\n\n  @media (min-width: 541px) and (max-width: 767.98px) {\n    .swipe-text.right {\n      margin-top: 75px;\n      margin-right: 30px;\n    }\n    .swipe-text.left {\n      margin-top: 195px;\n      margin-left: -40px;\n    }\n    .swipe-text {\n      font-size: 15px;\n    }\n    .swipe-text.right i {\n      font-size: 15px;\n    }\n    .swipe-text.left i {\n      font-size: 15px;\n    }\n    .swipe-text.comment i {\n      font-size: 15px;\n    }\n    .swipe-text.question i {\n      font-size: 15px;\n    }\n  }\n\n  @media (min-width: 400px) and (max-width: 540.98px) {\n    .swipe-text.right {\n      margin-top: 43px;\n      margin-right: 5px;\n    }\n    .swipe-text.left {\n      margin-top: 121px;\n      margin-left: -10px;\n    }\n    .swipe-text {\n      font-size: 15px;\n    }\n    .swipe-text.right i {\n      font-size: 15px;\n    }\n    .swipe-text.left i {\n      font-size: 15px;\n    }\n    .swipe-text.comment i {\n      font-size: 15px;\n    }\n    .swipe-text.question i {\n      font-size: 15px;\n    }\n  }\n\n  @media (min-width: 300px) and (max-width: 399.98px) {\n    .swipe-text.right {\n      margin-top: 37px;\n      margin-right: -15px;\n    }\n    .swipe-text.left {\n      margin-top: 121px;\n      margin-left: 0px;\n    }\n    .swipe-text {\n      font-size: 15px;\n    }\n    .swipe-text.right i {\n      font-size: 15px;\n    }\n    .swipe-text.left i {\n      font-size: 15px;\n    }\n    .swipe-text.comment i {\n      font-size: 15px;\n    }\n    .swipe-text.question i {\n      font-size: 15px;\n    }\n  } */\n\n  /* -----------new responsive---------- */\n  /* @media (max-width: 1920px) { \n    .swipe-text.right {\n      margin-top: 145px;\n      margin-right: 144px;\n    }\n    .swipe-text.left {\n      margin-top: 250px;\n      margin-left: 170px;\n    }\n  }\n  @media (max-width: 1600px) { \n    .swipe-text.right {\n      margin-top: 105px;\n    }\n    .swipe-text.left {\n      margin-top: 220px;\n    }\n  } \n  @media (max-width: 1536px) { \n    .swipe-text.right {\n      margin-top: 95px;\n    }\n    .swipe-text.left {\n      margin-top: 210px;\n    }\n  } \n  @media (max-width: 1440px) { \n    .swipe-text.right {\n      margin-top: 85px;\n    }\n    .swipe-text.left {\n      margin-top: 200px;\n    }\n  } \n  @media (max-width: 1336px) { \n    .swipe-text.right {\n      margin-top: 75px;\n    }\n    .swipe-text.left {\n      margin-top: 190px;\n    }\n  } \n  @media (max-width: 1280px) { \n    .swipe-text{\n      font-size: 20px;\n    }\n    .swipe-text i {\n      font-size: 26px !important;\n    }\n  } \n  @media (max-width: 912px) { \n    .swipe-text.right {\n      margin-right: 34px;\n      margin-top: 195px;\n    }\n    .swipe-text.left {\n      margin-left: 60px;\n      margin-top: 310px;\n    }    \n  }\n  @media (max-width: 884.98px) { \n    .swipe-text.right {\n      margin-top: 135px;\n    }\n    .swipe-text.left {\n      margin-top: 250px;\n    }    \n  }\n  @media (max-width: 834.98px) { \n    .swipe-text{\n      font-size: 18px;\n    }\n    .swipe-text.right {\n      margin-top: 155px;\n      margin-right: 34px;\n    }\n    .swipe-text.left {\n      margin-top: 260px;\n      margin-left: 60px;\n    }  \n    #instruction-overlay-div {\n      top: 32%;\n  }    \n  #instruction-overlay-auth-div {\n    top: 32%;\n}    \n  }\n  @media (max-width: 820.98px) { \n    .swipe-text.right {\n      margin-top: 145px;\n    }\n    .swipe-text.left {\n      margin-top: 260px;\n    }    \n  }\n  @media (max-width: 800.98px) { \n    .swipe-text.right {\n      margin-top: 165px;\n    }\n    .swipe-text.left {\n      margin-top: 280px;\n    }    \n  }\n  @media (max-width: 768.98px) { \n    .swipe-text{\n      font-size: 18px;\n    }\n    .swipe-text.right {\n      margin-right: 34px;\n      margin-top: 115px;\n    }\n    .swipe-text.left {\n      margin-left: 60px;\n      margin-top: 230px;\n    }  \n    #instruction-overlay-div {\n      top: 28%;\n  }      \n  #instruction-overlay-auth-div {\n    top: 22%;\n} \n  }\n\n  @media (max-width: 540.98px) { \n    .swipe-text.right {\n      margin-right: 4px;\n      margin-top: 45px;\n    }\n    .swipe-text.left {\n      margin-top: 100px;\n      margin-left: -10px;\n    }    \n  }\n\n  @media (max-width: 425.98px) { \n    .swipe-text{\n      font-size: 14px;\n    }\n    .swipe-text.right {\n      margin-right: 4px;\n      margin-top: 25px;\n    }\n    .swipe-text.left {\n      margin-top: 115px;\n      margin-left: -10px;\n    } \n    #instruction-overlay-div {\n      top: 16%;\n  }   \n  #instruction-overlay-auth-div {\n    top: 16%;\n}   \n  }\n  @media (max-width: 414.98px) { \n    .swipe-text.right {\n      margin-right: 4px;\n      margin-top: 60px;\n    }\n    .swipe-text.left {\n      margin-left: 0px;\n    } \n  }\n  @media only screen and (max-width: 600px) and (min-width: 400px)  {\n    #instruction-overlay-auth-div {\n      top: 22%;\n  }   \n  }\n  @media (max-width: 393.98px) { \n    .swipe-text{\n      font-size: 14px;\n    }\n    .swipe-text.right {\n      margin-right: -6px;\n      margin-top: 50px;\n    }\n    .swipe-text.left {\n      margin-left: 10px;\n    }    \n  }\n  @media (max-width: 390.98px) { \n    .swipe-text.right {\n      margin-top: 35px;\n    }\n    .swipe-text.left {\n      margin-left: 10px;\n    }    \n  }\n  @media (max-width: 375.98px) { \n    .swipe-text.right {\n      margin-right: -16px;\n      margin-top: 25px;\n    }\n    .swipe-text.left {\n      margin-top: 115px;\n      margin-left: 10px;\n    }    \n  }\n  @media (max-width: 360.98px) { \n    .swipe-text.right {\n      margin-top: 45px;\n  }\n  }\n  @media (max-width: 320.98px) { \n    .swipe-text{\n      font-size: 12px;\n    }\n    .swipe-text i {\n      font-size: 20px !important;\n    }\n    .swipe-text.right {\n      margin-top: 35px;\n  }\n  }\n  @media (max-width: 280.98px) { \n    .swipe-text.left {\n      margin-left: 2px;\n  }\n  .swipe-text.right {\n    margin-top: 35px;\n}\n  } */\n\n  @media (max-width: 1280px) { \n    .swipe-text{\n      font-size: 20px;\n    }\n    .swipe-text i {\n      font-size: 26px !important;\n    }\n  } \n  @media (max-width: 834.98px) { \n    .swipe-text{\n      font-size: 18px;\n    }\n    \n}    \n  @media (max-width: 540.98px) { \n    .swipe-text{\n      font-size: 14px;\n    }\n  }\n  @media (max-width: 320.98px) { \n    .swipe-text{\n      font-size: 12px;\n    }\n    .swipe-text i {\n      font-size: 20px !important;\n    }\n  }\n  @media only screen and (max-width: 414px) and (min-width: 320px)  {\n    .progress-bar-container {\n      margin-bottom: 140px;\n    }\n  }  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
